module.exports = __webpack_public_path__ + "img/tagRota1.e24a6735.png";